import React from 'react'
import classes from './Spinner.css'

const spinner = (props) => (
  <div className={classes.SpinnerContainer}><div className={classes.LDSGrid}><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div>
)

export default spinner


// WEBPACK FOOTER //
// ./src/components/UI/Spinner/Spinner.js